import { render, staticRenderFns } from "./apiTokenComponent.vue?vue&type=template&id=71eb973a&scoped=true&"
import script from "./apiTokenComponent.vue?vue&type=script&lang=js&"
export * from "./apiTokenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eb973a",
  null
  
)

export default component.exports